<ng-container *transloco="let t">
<button mat-button class="max-w-60 mr-2 px-3 focus:outline-none" [matMenuTriggerFor]="locationMenu">
    <div class="flex items-center">
        <mat-icon class="icon-size-5 mr-2 opacity-70" svgIcon="heroicons_outline:map-pin"></mat-icon>
        <span class="truncate font-medium">
            {{ (activeLocation$ | async)?.name || t('layout.locationSelector.loading') }}
        </span>
        <mat-icon class="icon-size-4 ml-1 opacity-50" svgIcon="heroicons_solid:chevron-down"></mat-icon>
    </div>
</button>

<mat-menu #locationMenu="matMenu" [xPosition]="'before'">
    <div class="px-4 py-3 border-b">
        <span class="text-sm font-semibold text-secondary">{{ t('layout.locationSelector.title') }}</span>
    </div>

    @for (location of (locations$ | async); track location.id) {
    <button mat-menu-item (click)="selectLocation(location)"
        [ngClass]="{'bg-primary-50 dark:bg-hover': (activeLocation$ | async)?.id === location.id}">
        <span class="flex items-center">
            <span class="truncate"
                [ngClass]="{'font-semibold text-primary': (activeLocation$ | async)?.id === location.id}">
                {{ location.name }}
            </span>
            @if ((activeLocation$ | async)?.id === location.id) {
            <mat-icon class="ml-2 icon-size-4 text-primary" svgIcon="heroicons_outline:check"></mat-icon>
            }
        </span>
    </button>
    }

    <mat-divider></mat-divider>

    <button mat-menu-item (click)="manageLocations()">
        <mat-icon svgIcon="heroicons_outline:cog-8-tooth"></mat-icon>
        <span>{{ t('layout.locationSelector.manage') }}</span>
    </button>
</mat-menu>
</ng-container>
